import React, { Component } from "react"
import { SelectCustom } from "../../components"
import {
  RelatorioGestorForm,
  RelatorioFiscaisForm,
  RelatorioObjetoForm,
  RelatorioVigenciasForm,
  RelatorioVigenciasDiasRestantesForm,
  RelatorioContratadosForm,
  RelatorioBaixasForm,
  RelatorioConsumoForm,
  RelatorioBaixasSinteticoForm,
  RelatorioAditivosForm,
  RelatorioDeContratosVencidosForm,
  RelatorioSaldoForm,
  RelatorioFinalSaldoForm,
  RelatorioDistratosForm,
  RelatorioContratosGroupedByForm
} from "./index"

export default class RelatoriosForm extends Component {
  constructor() {
    super()
    this.onChangeTipo = this.onChangeTipo.bind(this)
    this.enableForm = this.enableForm.bind(this)
    this.state = {
      tipo: "",
      showVigenciaForm: false,
      showGestoresForm: false,
      showFiscaisForm: false,
      showContratadosForm: false,
      showObjetosForm: false,
      showVigenciaDiasForm: false,
      showConsumoMensalForm: false,
      showBaixasForm: false,
      showBaixasSinteticasForm: false,
      showAditivosForm: false,
      showSaldoForm: false,
      showFinalSaldoForm: false,
      showDistratos: false,
      showGroupedBy: false
    }
  }
  enableForm(value) {
    var newState = {
      showVigenciaForm: value === "0",
      showContratadosForm: value === "1",
      showGestoresForm: value === "2",
      showFiscaisForm: value === "3",
      showObjetosForm: value === "4",
      showVigenciaDiasForm: value === "5",
      showBaixasSinteticasForm: value === "6",
      showConsumoMensalForm: value === "7",
      showAditivosForm: value === "8",
      showVencidosForm: value === "9",
      showSaldoForm: value === "10",
      showFinalSaldoForm: value === "11",
      showDistratos: value === "12",
      showGroupedBy: value === "13"
    }
    this.setState(newState)
  }
  onChangeTipo(event) {
    var newValue = event.target.value
    this.enableForm(newValue)
    this.setState({
      tipo: newValue
    })
  }
  render() {
    return (
      <div className="container-fluid" id="rel-contrato">
        <div>
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Relatórios de contrato</h4>
              <p className="category" />
            </div>
            <div className="card-content">
              <div className="row">
                <SelectCustom
                  sizeClass="col-md-3"
                  options={this.props.tipos}
                  label="Tipo de relatório"
                  onChange={this.onChangeTipo}
                  value={this.state.tipo}
                />
              </div>
              <div className="row">
                <div className="col-md-9">
                  {this.state.showAditivosForm && <RelatorioAditivosForm />}
                  {this.state.showGestoresForm && <RelatorioGestorForm />}
                  {this.state.showFiscaisForm && <RelatorioFiscaisForm />}
                  {this.state.showObjetosForm && <RelatorioObjetoForm />}
                  {this.state.showVigenciaForm && <RelatorioVigenciasForm />}
                  {this.state.showVigenciaDiasForm && (
                    <RelatorioVigenciasDiasRestantesForm />
                  )}
                  {this.state.showContratadosForm && (
                    <RelatorioContratadosForm />
                  )}
                  {this.state.showBaixasForm && <RelatorioBaixasForm />}
                  {this.state.showConsumoMensalForm && <RelatorioConsumoForm />}
                  {this.state.showBaixasSinteticasForm && (
                    <RelatorioBaixasSinteticoForm />
                  )}
                  {this.state.showVencidosForm && (
                    <RelatorioDeContratosVencidosForm />
                  )}
                  {this.state.showSaldoForm && <RelatorioSaldoForm />}
                  {this.state.showFinalSaldoForm && <RelatorioFinalSaldoForm />}
                  {this.state.showDistratos && <RelatorioDistratosForm />}
                  {this.state.showGroupedBy && (
                    <RelatorioContratosGroupedByForm />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatoriosForm.js